const selectors = {
  elements: {
    scrollbarAttribute: 'data-scrollbar',
    scrollbar: 'data-scrollbar-slider',
    scrollbarSlideFullWidth: 'data-scrollbar-slide-fullwidth',
    scrollbarArrowPrev: '[data-scrollbar-arrow-prev]',
    scrollbarArrowNext: '[data-scrollbar-arrow-next]',
  },
  classes: {
    hide: 'is-hidden',
  },
  times: {
    delay: 200,
  },
};

class NativeScrollbar {
  constructor(scrollbar) {
    this.scrollbar = scrollbar;

    this.arrowNext = this.scrollbar.parentNode.querySelector(selectors.elements.scrollbarArrowNext);
    this.arrowPrev = this.scrollbar.parentNode.querySelector(selectors.elements.scrollbarArrowPrev);

    if (this.scrollbar.hasAttribute(selectors.elements.scrollbarAttribute)) {
      this.init();
      this.resize();
    }

    if (this.scrollbar.hasAttribute(selectors.elements.scrollbar)) {
      this.scrollToVisibleElement();
    }
  }

  init() {
    if (this.arrowNext && this.arrowPrev) {
      this.toggleNextArrow();

      this.events();
    }
  }

  resize() {
    document.addEventListener('theme:resize', () => {
      this.toggleNextArrow();
    });
  }

  events() {
    this.arrowNext.addEventListener('click', (event) => {
      event.preventDefault();

      this.goToNext();
    });

    this.arrowPrev.addEventListener('click', (event) => {
      event.preventDefault();

      this.goToPrev();
    });

    this.scrollbar.addEventListener('scroll', () => {
      this.togglePrevArrow();
      this.toggleNextArrow();
    });
  }

  goToNext() {
    const moveWith = this.scrollbar.hasAttribute(selectors.elements.scrollbarSlideFullWidth) ? this.scrollbar.getBoundingClientRect().width : this.scrollbar.getBoundingClientRect().width / 2;
    const position = moveWith + this.scrollbar.scrollLeft;

    this.move(position);

    this.arrowPrev.classList.remove(selectors.classes.hide);

    this.toggleNextArrow();
  }

  goToPrev() {
    const moveWith = this.scrollbar.hasAttribute(selectors.elements.scrollbarSlideFullWidth) ? this.scrollbar.getBoundingClientRect().width : this.scrollbar.getBoundingClientRect().width / 2;
    const position = this.scrollbar.scrollLeft - moveWith;

    this.move(position);

    this.arrowNext.classList.remove(selectors.classes.hide);

    this.togglePrevArrow();
  }

  toggleNextArrow() {
    setTimeout(() => {
      this.arrowNext.classList.toggle(selectors.classes.hide, Math.round(this.scrollbar.scrollLeft + this.scrollbar.getBoundingClientRect().width + 1) >= this.scrollbar.scrollWidth);
    }, selectors.times.delay);
  }

  togglePrevArrow() {
    setTimeout(() => {
      this.arrowPrev.classList.toggle(selectors.classes.hide, this.scrollbar.scrollLeft <= 0);
    }, selectors.times.delay);
  }

  scrollToVisibleElement() {
    [].forEach.call(this.scrollbar.children, (element) => {
      element.addEventListener('click', (event) => {
        event.preventDefault();

        this.move(element.offsetLeft - element.clientWidth);
      });
    });
  }

  move(offsetLeft) {
    this.scrollbar.scrollTo({
      top: 0,
      left: offsetLeft,
      behavior: 'smooth',
    });
  }
}

export default NativeScrollbar;
